import optionsBag from "../../models/options/optionsBag.js";

/**
 * PDF exporter for report disclaimers that builds a PDFMake doc definition.
 *
 * @param {company} spec.company - Company the report is for.
 * @param {object} spec.agency - Agency the company belongs to.
 */
export default class ReportDisclaimerPDFExporter {
	constructor({ company, reportDisclaimerTemplateVariables }) {
		this._company = company;

		this._reportDisclaimerTemplateVariables =
			reportDisclaimerTemplateVariables;
	}

	getStyles() {
		return {
			disclaimer: {
				margin: 50,
			},
			disclaimerHeader: {
				color: "#222222",
				fontSize: 16,
				bold: true,
				margin: [0, 0, 0, 20],
			},
			disclaimerContent: {
				color: "#999999",
				fontSize: 10,
				alignment: "justify",
				margin: [0, 0, 0, 20],
			},
			disclaimerFooter: {
				color: "#999999",
				fontSize: 10,
				alignment: "justify",
				margin: [0, 20, 0, 0],
			},
		};
	}

	exportReportDisclaimer() {
		if (!optionsBag.fromId("disclaimer").isActive()) {
			return {};
		}

		const templateVariables = this._reportDisclaimerTemplateVariables;

		return {
			table: {
				headerRows: 1,
				keepWithHeadRows: 1,
				body: [
					[
						{
							text: this._getReportDisclaimer().expandHeader(
								templateVariables,
							),
							border: [false, false, false, false],
							style: "disclaimerHeader",
						},
					],
					[
						{
							text: this._getReportDisclaimer().expandContent(
								templateVariables,
							),
							border: [false, false, false, false],
							style: "disclaimerContent",
						},
					],
					[
						{
							text: this._getReportDisclaimer().expandFooter(
								templateVariables,
							),
							style: "disclaimerFooter",
							border: [false, true, false, false],
						},
					],
				],
			},
			layout: {
				hLineColor: () => "#cccccc",
			},
			style: "disclaimer",
			pageBreak: "after",
		};
	}

	_getReportDisclaimer() {
		return this._company.getReportDisclaimer();
	}
}
